export type HandinPhase = "idle" | "submitting" | "queued" | "running";

/** Where a hand-in is. d-handin-card sets it on the elements inside it that show it. */
export type HandinProgress = {
    readonly phase: HandinPhase;
    // Judging takes longer than usual.
    readonly slow: boolean;
};

export const IDLE: HandinProgress = { phase: "idle", slow: false };

export function inProgress(progress: HandinProgress): boolean {
    return progress.phase !== "idle";
}
